import React, { useState } from "react";

const FilterDrawer = ({ show, onClose, setSelectedCategory, setSelectedPrices }) => {
  const [openPrice, setOpenPrice] = useState(false);
  const [openCategory, setOpenCategory] = useState(false);

  const [selectedPriceRanges, setSelectedPriceRanges] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  const priceOptions = [
    "800-1000",
    "1000-1200",
    "1200-1400",
    "1400-1600",
    "1600-1800",
    "1800-2000",
  ];

  const categoryOptions = [
    "Linen",
    "Cotton",
    "Oxford",
    "Cotton-Linen Blend",
  ];

  const togglePrice = (range) => {
    setSelectedPriceRanges((prev) =>
      prev.includes(range) ? prev.filter((r) => r !== range) : [...prev, range]
    );
  };

  const toggleCategory = (cat) => {
    setSelectedCategories((prev) =>
      prev.includes(cat) ? prev.filter((c) => c !== cat) : [...prev, cat]
    );
  };

  const handleApply = () => {
    setSelectedCategory(selectedCategories);
    setSelectedPrices(selectedPriceRanges);
    onClose();
  };

  return (
    <div className={`filter-drawer ${show ? "open" : ""}`}>
      <div className="filter-header">
        <h4>Filter</h4>
        <button className="close-btn" onClick={onClose}>✕</button>
      </div>

      <div className="filter-content">

        {/* PRICE SECTION */}
        <div className="dropdown-section">
          <div className="dropdown-header" onClick={() => setOpenPrice(!openPrice)}>
            <h5>Price</h5>
            <span className={`dropdown-icon ${openPrice ? "rotate" : ""}`}>▼</span>
          </div>

          {openPrice && (
            <div className="dropdown-body">
              {priceOptions.map((range) => (
                <label key={range} className="checkbox-item">
                  <input
                    type="checkbox"
                    checked={selectedPriceRanges.includes(range)}
                    onChange={() => togglePrice(range)}
                  />
                  {range}
                </label>
              ))}
            </div>
          )}
        </div>

        {/* CATEGORY SECTION */}
        <div className="dropdown-section">
          <div className="dropdown-header" onClick={() => setOpenCategory(!openCategory)}>
            <h5>Category</h5>
            <span className={`dropdown-icon ${openCategory ? "rotate" : ""}`}>▼</span>
          </div>

          {openCategory && (
            <div className="dropdown-body">
              {categoryOptions.map((cat) => (
                <label key={cat} className="checkbox-item">
                  <input
                    type="checkbox"
                    checked={selectedCategories.includes(cat)}
                    onChange={() => toggleCategory(cat)}
                  />
                  {cat}
                </label>
              ))}
            </div>
          )}
        </div>

      </div>

      <div className="filter-footer">
        <button className="apply-btn" onClick={handleApply}>Apply</button>
      </div>
    </div>
  );
};

export default FilterDrawer;
